import { Injectable, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment as ENV } from '@environments/environment';
import { UtilsService } from '../util/utils.service';
declare const AwsWafIntegration: {
  getToken(): Promise<string | null>;
};

@Injectable({providedIn: 'root'})
export class WafService {

  constructor(
    private readonly rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly _utilS: UtilsService
  ) { }

  public async ensureWafLoadedAndTokenAvailable(): Promise<boolean> {
    const currentStatus = this._utilS.wafToken;
    const existingScript = this.document.getElementById('awsWafIntegrationScript');
    if (currentStatus && existingScript) return true;  
    const renderer = this.rendererFactory.createRenderer(null, null);
    const script: HTMLScriptElement = renderer.createElement('script');
    renderer.setAttribute(script, 'id', 'awsWafIntegrationScript');
    renderer.setAttribute(script, 'src', ENV.wafUrl);
    renderer.setAttribute(script, 'type', 'text/javascript');
    renderer.setAttribute(script, 'defer', 'true');
    renderer.appendChild(this.document.head, script);    
    return new Promise<boolean>((resolve) => {
      script.onload = async () => {
        try {
          const token = await AwsWafIntegration.getToken();
          this._utilS.wafToken.next(token);
          if (token) {
            resolve(true);
          } else {
            resolve(false);
          }
        } catch (e) {
          ENV.showLogs && console.error('[WafLoaderService] Error al extraer aws token', e);
          resolve(false);
        }
      };
      script.onerror = (_) => {
        resolve(false);
      };
    });
  }

}